import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IGalleryType } from "../gallerytypeModel";

export const getAllGalleryType = createAsyncThunk(
  "GalleryType/FindAllGalleryType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/FindAllGalleryType`,
        {
          GalleryType: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching GalleryType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createGalleryType = createAsyncThunk(
  "GalleryType/InsertGalleryType",
  async (GalleryTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/InsertGalleryType`,
        GalleryTypeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating GalleryType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateGalleryType = createAsyncThunk(
  "GalleryType/UpdateGalleryType",
  async (GalleryTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/UpdateGalleryType`,
        GalleryTypeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating GalleryType:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteGalleryType = createAsyncThunk(
  "GalleryType/DeleteGalleryType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/DeleteGalleryType`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting GalleryType :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getGalleryTypeByID = createAsyncThunk(
  "GalleryType/FindByIDGalleryType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/FindByIDGalleryType`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        GalleryType: result.GalleryType,
         
        IsActive: result.IsActive ? 1 : 2,
      } as IGalleryType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveGalleryType = createAsyncThunk(
  "GalleryType/FindAllActiveGalleryType",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/GalleryType/FindAllActiveGalleryType`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveGalleryType = createAsyncThunk(
  "GalleryType/ActiveInActiveGalleryType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/ActiveInActiveGalleryType`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive GalleryType :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const GalleryTypeImageUpload = createAsyncThunk(
  "GalleryType/GalleryTypeImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GalleryType/GalleryTypeImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload GalleryType Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
